/* eslint-disable react/destructuring-assignment */
import Icon from "@ant-design/icons";
import { Button, Image } from "antd";
import React from "react";
import EngagedAI from "../../../static/EngagedAi_trans_bg.svg";
import { EMAIL_TYPE_ENUMS } from "../../constant/EmailConstant";
import CalenderIcon from "../../icons/svg/Calendar.svg";
import MikeIcon from "../../icons/svg/mike.svg";

export const EmailHeader = ({ lead }) => {
  return (
    <div className="flex flex-row items-center w-full relative bg-[#F1F5F9] rounded-md rounded-b-none p-4">
      <div className="text-center flex flex-col justify-center items-center w-full">
        <div className="py-2">
          <Icon className="text-5xl font-[600]" component={EngagedAI} alt="EngagedAi" />
        </div>
        {lead && (
          <div className="flex flex-col items-center mt-2">
            <span className="text-base font-[400] text-grey-700">{lead?.fullName || ""}</span>
            <span className="text-base font-[400] text-grey-700">
              {lead?.location?.title || ""}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export const EmailTypeIcon = ({ type, className }) => {
  const icons = {
    [EMAIL_TYPE_ENUMS.APPOINTMENT]: CalenderIcon,
    [EMAIL_TYPE_ENUMS.CAMPAIGN]: MikeIcon,
  };

  return (
    <Image
      preview={false}
      className={`w-4 mb-[2px] ${className}`}
      src={icons[type] || icons[EMAIL_TYPE_ENUMS.EMAIL]}
      alt={type}
    />
  );
};
